// extracted by mini-css-extract-plugin
module.exports = {"calc_detail_wrap":"calcDetail_calc_detail_wrap__1_Ay4","stiky_btn":"calcDetail_stiky_btn__1Zz2t","calc_detail_wrap_last":"calcDetail_calc_detail_wrap_last__fZYJH"};